import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGifts, faQrcode } from '@fortawesome/free-solid-svg-icons';
import giftitimage from '../../assets/pageimages/GiftIt.webp';

function GiftItHome() {
  return (
    <MainLayout>
      <div className="bg-gradient-to-r from-purple-300 via-pink-300 to-red-300 min-h-screen p-4 sm:p-8">
      <h2 className='text-3xl font-bold text-blue-800 text-center mb-6'>GiftIt</h2>
        <div className="flex justify-center mb-8">
          <img
            id="giftit-id"
            src={giftitimage}
            alt="GiftIt"
            className="w-full sm:w-3/4 lg:w-1/4 rounded-lg shadow-lg"
          />
        </div>

        {/* <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 p-6 rounded-lg shadow-lg mb-8"> */}
          <div className="flex flex-col sm:flex-row justify-center items-center">
            <Link 
              to="/giftit-igifted" 
              className="mr-4 w-full flex justify-center items-center text-white text-lg sm:text-xl font-semibold bg-blue-600 hover:bg-blue-500 rounded-lg px-6 py-3 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faGifts} className="mr-2" />
              I Gifted
            </Link>
            <Link 
              to="/giftit-giftstome" 
              className="w-full flex justify-center items-center text-white text-lg sm:text-xl font-semibold bg-teal-700 hover:bg-teal-600 rounded-lg px-6 py-3 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faQrcode} className="mr-2" />
              Gifts to Me
            </Link>
          </div>
        {/* </div> */}

      </div>
    </MainLayout>
  );
}

export default GiftItHome;
